import standardAction from '../../../utilities/standard-action';
import ActionTypes from '../constants/action-types';

function setShopifyParams(params: Record<string, string>) {
  return standardAction(ActionTypes.SHOPIFY_SET_PARAMS, params);
}

export default setShopifyParams;
